import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { DATABRICKS } from "../../Constants"

function ZdqDatabricksConnectorStatus() {
    return <ZdqConnectorStatus vendor={DATABRICKS}></ZdqConnectorStatus>
}

export default ZdqDatabricksConnectorStatus